import { useProfile } from "../../apis";
import { ModeratorRoutesPrivileges } from "../../constants";

/**
 * Whether the current admin may access a section gated by `privilege`.
 *
 * Super admins bypass every check. Reads the already-loaded profile from the
 * React Query cache (`enabled: false` — it never triggers its own fetch), so it
 * is safe to call both above and inside `MainLayout`; it re-evaluates once the
 * profile finishes loading.
 *
 * Use it to gate background queries (e.g. sidebar counters) so a moderator never
 * fires requests for sections they lack — no request, no 403, no toast.
 */
export const useHasPrivilege = (
  privilege: ModeratorRoutesPrivileges
): boolean => {
  const { user } = useProfile({ enabled: false });

  if (!user?.role) return false;

  return user.role === "Super" || (user.privileges?.includes(privilege) ?? false);
};
